export const CREATE_ONBOARDING_NOVA_CONTA = 'CREATE_ONBOARDING_NOVA_CONTA'
export const CREATE_ONBOARDING_NOVA_CONTA_PENDING = 'CREATE_ONBOARDING_NOVA_CONTA_PENDING'
export const CREATE_ONBOARDING_NOVA_CONTA_SUCCESS = 'CREATE_ONBOARDING_NOVA_CONTA_SUCCESS'
export const CREATE_ONBOARDING_NOVA_CONTA_FAILURE = 'CREATE_ONBOARDING_NOVA_CONTA_FAILURE'
